export class PINChangeRequest{
    public currentpin : string;
    public newpin : string
}